import { InfrastructureError } from '@goodt-wcore/errors';

export class TransportFactoryError extends InfrastructureError {
    constructor(message) {
        super(message);
        this.name = 'TransportFactoryError';
    }
}
